
/* 
 * Masonry layouts are not natively supported in pure SCSS/CSS, and we
 * must rely on hacks like explained here: https://tobiasahlin.com/blog/masonry-with-css/
 * To maintain three-grid layout as user interacts with the checklist, we
 * must keep the sublist wrapper container at a fixed height
 * that is taller than the longest column in the grid.
 * 
 * To do that, getSublistContainerHeight is called on window resize
 * item check/uncheck and on sublist close/open. 
 */

/**
 * A column includes every third sublist from the first node. 
 * This function finds and sums the heights of only every third column.
 * @param {Array} nodes an array of the HTMLnodes for all sublists
 * @returns {Number} height in pixels of the column
 */
const getColumnHeight = (nodes) => {
    let result = 0;
    for (let i = 0; i < nodes.length; i += 3) result += nodes[i].offsetHeight; // O(n/3)
    return result;
}

/**
 * @param {*} nodes an array of the HTMLnodes for all sublists
 * @returns {num} the height of the largest column, or the largest possible sublist container height
 */
export const getSublistContainerHeight = (nodes) => {
    return `${Math.max(
        getColumnHeight(nodes),
        // column 2 comprises of every third sublist after (and including) the second sublist
        getColumnHeight(nodes.slice(1)), 
        // column 3 comprises of every third sublist after (and including) the third sublist
        getColumnHeight(nodes.slice(2))
    )}px`;
};
